<template>
    <div v-if="blockedStatus !== OrderBlockedStatusViewObject.None"
         class="border border-warning-500 rounded-4 bg-warning-100"
         :class="[containerClass]">
        <h2 class="text-14 mb-8 font-semi-bold">
            <CIcon name="warning-danger" class="size-16"/>
            <span>
                {{ $dictionary.get('MyAccount.Order.History.Details.Blocked') }}
            </span>
        </h2>
        <p v-if="blockedStatus === OrderBlockedStatusViewObject.OutstandingCredit">
            {{ $dictionary.get('MyAccount.Order.History.Details.Blocked.OutstandingCredit') }}
        </p>
        <p v-else-if="blockedStatus === OrderBlockedStatusViewObject.MissingPrepayment">
            {{ $dictionary.get('MyAccount.Order.History.Details.Blocked.MissingPrepayment') }}
        </p>
        <p v-else-if="blockedStatus === OrderBlockedStatusViewObject.ManualReview">
            {{ $dictionary.get('MyAccount.Order.History.Details.Blocked.ManualReview') }}
        </p>
        <p v-else>
            {{ $dictionary.get('MyAccount.Order.History.Details.Blocked.Other') }}
        </p>
    </div>
</template>

<script setup lang="ts">
import { OrderBlockedStatusViewObject } from '@/types/apiServerContract';

const props = defineProps({
    blockedStatus: {
        type: Object as () => OrderBlockedStatusViewObject,
        required: true
    },
    containerClass: {
        type: String,
        required: false,
        default: 'py-16 px-24'
    }
});
</script>
